import ApiClient from "./ApiClient";

// Function to get subscription details
export const getSubscription = async () => {
  try {
    const response = await ApiClient().get("business/payment/subscription");
    return response.data;
  } catch (error) {
    // Handle 404 gracefully - user might not have a subscription yet
    if (error?.response?.status === 404) {
      console.log("No subscription found - user may not have subscribed yet");
      return { responseData: null }; // Return null data instead of throwing
    }
    
    // Log other errors but don't show toast for subscription fetch failures
    console.error("Error fetching subscription:", error);
    return { responseData: null }; // Return null data instead of throwing
  }
};
